import { UserState, Saved, UserMode } from '../types/userTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// ✅ ESTADO INICIAL COMPLETO Y TIPADO
const initialState: UserState = {
  id: undefined,
  email: undefined,
  rut: undefined,
  password: undefined,
  first_name: undefined,
  last_name: undefined,
  height: undefined,
  weight: undefined,
  birthday: undefined,
  sex: undefined,
  diabetes: false,
  heart_diseases: false,
  other_diseases: '',
  thrombosis: false,
  business_id: undefined,
  token: undefined,
  business: undefined,
  saveds: [],
  registerOuts: [],
  redirect: undefined,
  mode: UserMode.VIEWER,
  started: undefined,
};

// ✅ FUNCIÓN PURA E INMUTABLE
const removeObjectWithId = (arr: Saved[], id?: number): Saved[] => {
  if (!id) return arr;
  return arr.filter(obj => obj.id !== id);
};

const UserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state: UserState, action: PayloadAction<Partial<UserState>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    logout: () => {
      return initialState;
    },
    profile: (
      state: UserState,
      action: PayloadAction<{
        value: { business: any; saveds: Saved[]; registerOuts: any[] };
      }>
    ) => {
      return {
        ...state,
        business: action.payload.value.business,
        saveds: action.payload.value.saveds,
        registerOuts: action.payload.value.registerOuts,
      };
    },
    // ✅ INMUTABLE: Usar spread operator en lugar de push
    saveProtocol: (
      state: UserState,
      action: PayloadAction<{ value: Saved }>
    ) => {
      if (state.saveds) {
        state.saveds = [...state.saveds, action.payload.value];
      } else {
        state.saveds = [action.payload.value];
      }
    },
    // ✅ INMUTABLE: Usar función pura
    unsaveProtocol: (
      state: UserState,
      action: PayloadAction<{ value: number }>
    ) => {
      if (state.saveds) {
        state.saveds = removeObjectWithId(state.saveds, action.payload.value);
      }
    },
    redirect: (
      state: UserState,
      action: PayloadAction<{ redirect: string }>
    ) => {
      return {
        ...state,
        redirect: action.payload.redirect,
      };
    },
    setMode: (state: UserState, action: PayloadAction<{ mode: UserMode }>) => {
      return {
        ...state,
        mode: action.payload.mode,
      };
    },
    setStarted: (
      state: UserState,
      action: PayloadAction<{ started: string }>
    ) => {
      return {
        ...state,
        started: action.payload.started,
      };
    },
  },
});

export const userActions = UserSlice.actions;
export const userReducer = UserSlice.reducer;
